module.exports = __webpack_public_path__ + "img/shopping-bag.7d64abc0.svg";